module.exports = __webpack_public_path__ + "img/google-icon-blue.f72068ec.svg";